import React from 'react';
import styles from './PlayerRow.module.sass';
import RedCross from '../../../../../../../asset/videoSeries/RedCross.webp';
import PlayersGoal from '../../../../../../../asset/teams/roster/invitations/Players_goal.webp';
import { timeConvert } from '../../../../../../../utils/utils.js';
import { Avatars } from '../../../../../../../constants/const';
import { useHistory } from 'react-router-dom';
import IDP from './idp.png';
import IDP_DISABLED from './idp-grey.png';
import { useSelector } from 'react-redux';

export function PlayerRow(props) {
  const {
    playerData,
    thisItemOpen,
    setThisItemOpen,
    teamId,
    handleSelectedIDP,
    isManager,
    isPlayerManager,
  } = props;
  const history = useHistory();
  const playerID = useSelector((state) => state.playerDataReducer.playerData.id);
  const handleMenuClick = (event, data) => {
    const targetEvent = event.target.dataset.value;
    if (targetEvent !== thisItemOpen) {
      setThisItemOpen(targetEvent);
      history.push(`/profilePage/${data.childId}/${teamId}`);
    } else {
      setThisItemOpen('');
    }
  };

  const checkAccess = (player) => {
    if (isManager || isPlayerManager || playerID === player) {
      return true;
    }
    return false;
  };

  return (
    <>
      {playerData.map((data, index) => {
        const isMenuOpen = thisItemOpen === String(data.childId);
        const classSelector = data.isManager ? styles.cell_player_manager : styles.cell_player_name;
        const {
          childFirstName,
          childId,
          childLastName,
          countVideo,
          image,
          picture,
          playerStatusGoal,
          playerGoal,
          timeVideo,
        } = data;
        const fullName = childFirstName.concat(childLastName ? `${' ' + childLastName}` : ' ');
        return (
          <tr className={styles.row} key={childId}>
            <th scope="row" className={styles.cell_first}>
              {index + 1}
            </th>
            <td className={classSelector}>
              <img
                src={image || Avatars[parseInt(picture) - 1]}
                className={styles.cell_logo}
                alt=""
              />
              <span
                style={{
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                }}
                onClick={(e) => handleMenuClick(e, data)}
              >
                {fullName}
              </span>
            </td>
            <td className={styles.cell}>{countVideo}</td>
            <td className={styles.cell}>{timeVideo ? timeConvert(timeVideo) : '0m'}</td>
            <td className={styles.cell}>{playerGoal}</td>
            <td className={styles.cell}>
              <img className={styles.icon} src={playerStatusGoal ? PlayersGoal : RedCross} alt="" />
            </td>
            <td className={styles.cell}>
              <span
                className={`${styles.cell_idp} ${
                  checkAccess(childId) ? '' : styles.cell_idp_disabled
                }`}
                onClick={() => handleSelectedIDP(childId)}
              >
                <img src={checkAccess(childId) ? IDP : IDP_DISABLED} alt="IDP" />
              </span>
            </td>
          </tr>
        );
      })}
    </>
  );
}
